export default "__VITE_ASSET__CT2eNYiy__"